import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7811a341"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-product-property mb-3" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "d-flex align-items-center mb-1" }
const _hoisted_4 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text_editor = _resolveComponent("input-text-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("label", {
          for: _ctx.modelValue.property_type_code,
          class: "fw-bold me-2"
        }, _toDisplayString(_ctx.$t(_ctx.productPropertyType.description)), 9, _hoisted_4)
      ]),
      _createElementVNode("main", null, [
        _createVNode(_component_input_text_editor, {
          name: _ctx.modelValue.property_type_code,
          modelValue: _ctx.localText,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localText) = $event)),
            _ctx.emitNewValue
          ],
          height: 180,
          errors: _ctx.errors
        }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "errors"])
      ])
    ])
  ]))
}